import { Link, useLocation, useNavigate } from "react-router-dom";


const Navbar = () => {
  const navigate = useNavigate();
  let location = useLocation();

  // useEffect(() => {
    // eslint-disable-next-line
  //   console.log(location.pathname);
  // }, [location]);

  const handlelogout = () => {
    localStorage.removeItem('token');
    navigate("/login")
  }

  return (
    <nav className="navbar navbar-expand-lg " style={{ "backgroundColor": "rgb(203 211 219)" }} >
      <div className="container-fluid">
        <Link className="navbar-brand" to="#">YourBook</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === "/" ? "active" : ""}`} aria-current="page" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about">About</Link>
            </li>

          </ul>
          {!localStorage.getItem('token') ? <form className="d-flex" role="search">
            <Link className="btn btn-dark mx-2" to="/login" role="button">Log in</Link>
            <Link className="btn btn-dark mx-2" to="/signup" role="button">Sign Up</Link>
          </form>
            : <button className='btn btn-dark mx-2' onClick={handlelogout}>Log out</button>
          }
        </div>
      </div>
    </nav>
  )
}

export default Navbar
